import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { ROUTING_PATH } from '@shared/constants/routingPath';

const ForecastCurvesRoutes = {
  CUSTOM_CURVES: `/${ROUTING_PATH.FORECAST_ROUTING.INDEX}/${ROUTING_PATH.FORECAST_ROUTING.DRIVERS.INDEX}/${ROUTING_PATH.FORECAST_ROUTING.DRIVERS.CUSTOM_DRIVERS}`,
  PATIENT_CURVES: `/${ROUTING_PATH.FORECAST_ROUTING.INDEX}/${ROUTING_PATH.FORECAST_ROUTING.DRIVERS.INDEX}/${ROUTING_PATH.FORECAST_ROUTING.DRIVERS.PATIENT_DRIVER.INDEX}/${ROUTING_PATH.FORECAST_ROUTING.DRIVERS.PATIENT_DRIVER.CURVES}`,
  SITE_CURVES: `/${ROUTING_PATH.FORECAST_ROUTING.INDEX}/${ROUTING_PATH.FORECAST_ROUTING.DRIVERS.INDEX}/${ROUTING_PATH.FORECAST_ROUTING.DRIVERS.SITE_DRIVER.INDEX}/${ROUTING_PATH.FORECAST_ROUTING.DRIVERS.SITE_DRIVER.CURVES}`,
};

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink],
  selector: 'aux-forecast-curves-row-title',
  styles: [
    `
      :host {
        flex-grow: 1;

        .link {
          color: rgba(9, 91, 149);
        }
      }
    `,
  ],
  template: `
    <span
      class="btn--hyperlink cursor-pointer px-0"
      [routerLink]="ForecastCurvesRoutes.SITE_CURVES"
    >
      Site
    </span>
    <span>{{ ', ' }}</span>
    <span
      class="btn--hyperlink cursor-pointer px-0"
      [routerLink]="ForecastCurvesRoutes.PATIENT_CURVES"
    >
      Patient
    </span>
    <span>{{ ', & ' }}</span>
    <span
      class="btn--hyperlink cursor-pointer px-0"
      [routerLink]="ForecastCurvesRoutes.CUSTOM_CURVES"
    >
      Custom
    </span>
    Curves
  `,
})
export class ForecastCurvesRowTitleComponent {
  readonly ForecastCurvesRoutes = ForecastCurvesRoutes;
}
